"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5734],{

/***/ 15734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Typography; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Typography/typography.js



function Typography(props, ref) {
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var prefixCls = getPrefixCls('typography');
    var className = props.className, style = props.style, children = props.children;
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, className);
    return (react.createElement("article", { ref: ref, style: style, className: classNames }, children));
}
var TypographyComponent = (0,react.forwardRef)(Typography);
TypographyComponent.displayName = 'Typography';
/* harmony default export */ var typography = (TypographyComponent);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/resizeObserver.js
var resizeObserver = __webpack_require__(68761);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useKeyboardEvent.js
var useKeyboardEvent = __webpack_require__(57483);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Tooltip/index.js
var Tooltip = __webpack_require__(15695);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_util/clipboard.js
// https://github.com/feross/clipboard-copy/blob/master/index.js
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
function clipboard(text) {
    return __awaiter(this, void 0, void 0, function () {
        var err_1, span, selection, range, success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(navigator.clipboard && navigator.clipboard.writeText)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(text)];
                case 2:
                    _a.sent();
                    // 仅在执行成功时返回
                    return [2 /*return*/];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1 !== null && err_1 !== void 0 ? err_1 : new DOMException('The request is not allowed', 'NotAllowedError'));
                    return [3 /*break*/, 4];
                case 4:
                    span = document.createElement('span');
                    span.textContent = text;
                    span.style.whiteSpace = 'pre';
                    document.body.appendChild(span);
                    selection = window.getSelection();
                    range = window.document.createRange();
                    selection.removeAllRanges();
                    range.selectNode(span);
                    selection.addRange(range);
                    success = false;
                    try {
                        success = window.document.execCommand('copy');
                    }
                    catch (err) {
                        // eslint-disable-next-line
                        console.log('error', err);
                    }
                    selection.removeAllRanges();
                    window.document.body.removeChild(span);
                    return [2 /*return*/, success
                            ? Promise.resolve()
                            : Promise.reject(new DOMException('The request is not allowed', 'NotAllowedError'))];
            }
        });
    });
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCopy/index.js
var IconCopy = __webpack_require__(38460);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCheckCircleFill/index.js
var IconCheckCircleFill = __webpack_require__(19530);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconEdit/index.js
var IconEdit = __webpack_require__(61803);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_util/mergedToString.js
/** merge multiple children to a string node */


var isSingleNode = function (child) {
    return (0,is/* isString */.HD)(child) || (0,is/* isNumber */.hj)(child);
};
function mergedToString(children) {
    var mergedResult = [''];
    react.Children.forEach(children, function (child) {
        var prevIndex = mergedResult.length - 1;
        var prevChild = mergedResult[prevIndex];
        if (isSingleNode(child) && isSingleNode(prevChild)) {
            mergedResult[prevIndex] = "" + prevChild + child;
        }
        else if (child && child.props && child.props.children) {
            mergedResult.push(mergedToString(child.props.children));
        }
    });
    return mergedResult.join('');
}

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Typography/operations.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};









function Operations(props) {
    var children = props.children, copyable = props.copyable, editable = props.editable, ellipsis = props.ellipsis, expanding = props.expanding, setEditing = props.setEditing, onClickExpand = props.onClickExpand, forceShowExpand = props.forceShowExpand, isEllipsis = props.isEllipsis, _a = props.currentContext, currentContext = _a === void 0 ? {} : _a;
    var getEventListeners = (0,useKeyboardEvent/* default */.Z)();
    var getPrefixCls = currentContext.getPrefixCls, locale = currentContext.locale;
    var prefixCls = getPrefixCls('typography');
    var _b = __read((0,react.useState)(false), 2), isCopied = _b[0], setCopied = _b[1];
    var copyTimer = (0,react.useRef)(null);
    var copyConfig = (0,is/* isObject */.Kn)(copyable) ? copyable : {};
    var ellipsisConfig = (0,is/* isObject */.Kn)(ellipsis) ? ellipsis : {};
    var editableConfig = (0,is/* isObject */.Kn)(editable) ? editable : {};
    var expandNodes = (0,is/* isArray */.kJ)(ellipsisConfig.expandNodes)
        ? ellipsisConfig.expandNodes
        : [locale.Typography.fold, locale.Typography.unfold];
    (0,react.useEffect)(function () {
        return function () {
            clearTimeout(copyTimer.current);
            copyTimer.current = null;
        };
    }, []);
    function onClickCopy(e) {
        if (isCopied)
            return;
        var text = copyConfig.text !== undefined ? copyConfig.text : mergedToString(children);
        clipboard(text);
        setCopied(true);
        copyConfig.onCopy && copyConfig.onCopy(text, e);
        copyTimer.current = setTimeout(function () {
            setCopied(false);
        }, 3000);
    }
    var onClickEdit = function (e) {
        editableConfig.onStart && editableConfig.onStart(mergedToString(children), e);
        setEditing(true);
    };
    var tooltips = copyConfig.tooltips || [locale.Typography.copy, locale.Typography.copied];
    var copyElement = copyable && (react.createElement(Tooltip/* default */.Z, { content: isCopied ? tooltips[1] : tooltips[0] },
        react.createElement("span", __assign({ className: isCopied ? prefixCls + "-operation-copied" : prefixCls + "-operation-copy", onClick: onClickCopy, role: "button", "aria-label": tooltips[0], tabIndex: 0 }, getEventListeners({
            onPressEnter: onClickCopy,
        })), isCopied ? react.createElement(IconCheckCircleFill/* default */.Z, null) : copyConfig.icon || react.createElement(IconCopy/* default */.Z, null))));
    var editElement = editable && (react.createElement(Tooltip/* default */.Z, { content: locale.Typography.edit },
        react.createElement("span", __assign({ tabIndex: 0, "aria-label": locale.Typography.edit, role: "button", className: prefixCls + "-operation-edit", onClick: onClickEdit }, getEventListeners({
            onPressEnter: onClickEdit,
        })),
            react.createElement(IconEdit/* default */.Z, null))));
    var ellipsisElement = forceShowExpand || (ellipsisConfig.expandable && isEllipsis) ? (react.createElement("a", __assign({ className: prefixCls + "-operation-expand", onClick: onClickExpand, role: "button", tabIndex: 0, "aria-label": locale.Typography.unfold }, getEventListeners({
        onPressEnter: onClickExpand,
    })), expanding ? expandNodes[0] : expandNodes[1])) : null;
    return (react.createElement(react.Fragment, null,
        ellipsisElement,
        editElement,
        copyElement));
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Input/index.js + 6 modules
var Input = __webpack_require__(1393);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Typography/edit-content.js




function EditContent(props) {
    var prefixCls = props.prefixCls, children = props.children, setEditing = props.setEditing, editableConfig = props.editableConfig, style = props.style;
    var className = (0,_util_classNames/* default */.Z)(prefixCls + "-typography", prefixCls + "-edit-content", props.className);
    var str = mergedToString(children);
    var input = (0,react.useRef)(null);
    (0,react.useEffect)(function () {
        input.current && input.current.focus && input.current.focus();
        if (input.current && input.current.dom) {
            var length_1 = input.current.dom.value.length;
            input.current.dom.setSelectionRange(length_1, length_1);
        }
    }, []);
    function onEnd() {
        setEditing(false);
        editableConfig.onEnd && editableConfig.onEnd(str);
    }
    function onChange(value) {
        editableConfig.onChange && editableConfig.onChange(value);
    }
    function onBlur() {
        onEnd();
    }
    return (react.createElement("div", { className: className, style: style },
        react.createElement(Input/* default.TextArea */.Z.TextArea, { className: prefixCls + "-edit-content-textarea", onBlur: onBlur, ref: input, value: str, autoSize: true, onChange: onChange, onPressEnter: onEnd })));
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Popover/index.js
var Popover = __webpack_require__(27339);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/omit.js
var omit = __webpack_require__(50049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useUpdate.js
var useUpdate = __webpack_require__(1083);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeValue.js
var useMergeValue = __webpack_require__(15955);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/throttleByRaf.js
var throttleByRaf = __webpack_require__(40694);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useIsomorphicLayoutEffect.js
var useIsomorphicLayoutEffect = __webpack_require__(81109);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Typography/useEllipsis.js
var useEllipsis_assign = (undefined && undefined.__assign) || function () {
    useEllipsis_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return useEllipsis_assign.apply(this, arguments);
};
var useEllipsis_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};





// line-height baseline
var MEASURE_LINE_HEIGHT_TEXT = 'hxj';
var MEASURE_STATUS;
(function (MEASURE_STATUS) {
    MEASURE_STATUS[MEASURE_STATUS["INIT"] = 0] = "INIT";
    MEASURE_STATUS[MEASURE_STATUS["BEFORE_MEASURE"] = 1] = "BEFORE_MEASURE";
    MEASURE_STATUS[MEASURE_STATUS["MEASURING"] = 2] = "MEASURING";
    MEASURE_STATUS[MEASURE_STATUS["MEASURE_END"] = 3] = "MEASURE_END";
    MEASURE_STATUS[MEASURE_STATUS["NO_NEED_ELLIPSIS"] = 4] = "NO_NEED_ELLIPSIS";
})(MEASURE_STATUS || (MEASURE_STATUS = {}));
function useEllipsis(props) {
    var children = props.children, _a = props.rows, rows = _a === void 0 ? 1 : _a, width = props.width, expanding = props.expanding, renderMeasureContent = props.renderMeasureContent, simpleEllipsis = props.simpleEllipsis, onEllipsis = props.onEllipsis, suffix = props.suffix, expandNodes = props.expandNodes, expandable = props.expandable, ellipsisStr = props.ellipsisStr;
    var singleRowNode = (0,react.useRef)();
    var mirrorNode = (0,react.useRef)();
    var _b = useEllipsis_read((0,react.useState)([0, 0, 0]), 2), binarySearchIndex = _b[0], setBinarySearchIndex = _b[1];
    var _c = useEllipsis_read((0,react.useState)(0), 2), lineHeight = _c[0], setLineHeight = _c[1];
    var _d = useEllipsis_read((0,react.useState)(MEASURE_STATUS.NO_NEED_ELLIPSIS), 2), status = _d[0], setStatus = _d[1];
    var _e = useEllipsis_read(binarySearchIndex, 3), startLoc = _e[0], midLoc = _e[1], endLoc = _e[2];
    var _f = useEllipsis_read((0,react.useState)(false), 2), isEllipsis = _f[0], setIsEllipsis = _f[1];
    var nodeList = (0,react.useMemo)(function () { return react.Children.toArray(children); }, [children]);
    var closedLoc = (0,react.useRef)(0);
    (0,useUpdate/* default */.Z)(function () {
        onEllipsis && onEllipsis(isEllipsis);
    }, [isEllipsis]);
    var isSimpleNode = function (node) {
        return (0,is/* isString */.HD)(node) || (0,is/* isNumber */.hj)(node);
    };
    var getTotalLen = function (list) {
        var total = 0;
        list.forEach(function (node) {
            if (isSimpleNode) {
                total += String(node).length;
            }
            else {
                total += 1;
            }
        });
        return total;
    };
    var totalLen = (0,react.useMemo)(function () { return getTotalLen(nodeList); }, [nodeList]);
    var updateSearchIndex = (0,throttleByRaf/* default */.Z)(function (searchIndex) { return setBinarySearchIndex(searchIndex); });
    var getSlicedNode = function (sliceLen) {
        var slicedNode = [];
        var currentLen = 0;
        if (sliceLen >= totalLen) {
            return nodeList;
        }
        for (var index in nodeList) {
            var node = nodeList[index];
            if (currentLen >= sliceLen) {
                return slicedNode;
            }
            var currentNodeLen = isSimpleNode(node) ? String(node).length : 1;
            if (currentNodeLen > sliceLen - currentLen) {
                slicedNode.push(String(node).slice(0, sliceLen - currentLen));
                currentLen = sliceLen;
                return slicedNode;
            }
            currentLen += currentNodeLen;
            slicedNode.push(node);
        }
        return slicedNode;
    };
    var measure = function () {
        var _a, _b;
        if (lineHeight) {
            if (status === MEASURE_STATUS.INIT) {
                var maxHeight = rows * lineHeight;
                var mirrorHeight = (_a = mirrorNode.current) === null || _a === void 0 ? void 0 : _a.offsetHeight;
                var currentEllipsis = mirrorHeight > maxHeight;
                // simpleEllipsis 和 expanding 情况下: 只用判断空间是否足够，不用计算折叠零界
                if (!currentEllipsis || simpleEllipsis || expanding) {
                    setStatus(MEASURE_STATUS.MEASURE_END);
                    setIsEllipsis(currentEllipsis);
                    setBinarySearchIndex([0, totalLen, totalLen]);
                }
                else {
                    setIsEllipsis(true);
                    setStatus(MEASURE_STATUS.BEFORE_MEASURE);
                }
            }
            else if (status === MEASURE_STATUS.BEFORE_MEASURE) {
                var totalWidth = singleRowNode === null || singleRowNode === void 0 ? void 0 : singleRowNode.current.offsetWidth;
                var closedWidth = rows * width;
                if (totalWidth > rows * width) {
                    var startRatio = Math.max(closedWidth / totalWidth - 0.1, 0);
                    var endRatio = Math.min(closedWidth / totalWidth + 0.1, 1);
                    var closedStartLoc = Math.floor(startRatio * totalLen);
                    var closedEndLoc = Math.ceil(endRatio * totalLen);
                    var closedMiddleLoc = Math.floor((closedStartLoc + closedEndLoc) / 2);
                    closedLoc.current = closedMiddleLoc;
                }
                setStatus(MEASURE_STATUS.MEASURING);
            }
            else if (status === MEASURE_STATUS.MEASURING) {
                if (startLoc !== endLoc - 1) {
                    var mirrorHeight = (_b = mirrorNode.current) === null || _b === void 0 ? void 0 : _b.offsetHeight;
                    var maxHeight = rows * lineHeight;
                    var nextStartLoc = startLoc;
                    var nextEndLoc = endLoc;
                    if (mirrorHeight <= maxHeight) {
                        nextStartLoc = midLoc;
                    }
                    else {
                        nextEndLoc = midLoc;
                    }
                    var nextMidLoc = Math.floor((nextEndLoc + nextStartLoc) / 2);
                    updateSearchIndex([nextStartLoc, nextMidLoc, nextEndLoc]);
                }
                else {
                    updateSearchIndex([startLoc, startLoc, startLoc]);
                    setStatus(MEASURE_STATUS.MEASURE_END);
                }
            }
        }
    };
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        if (props.rows && width) {
            setBinarySearchIndex([0, Math.floor(totalLen / 2), totalLen]);
            setStatus(MEASURE_STATUS.INIT);
        }
        else {
            setStatus(MEASURE_STATUS.NO_NEED_ELLIPSIS);
        }
    }, [
        totalLen,
        simpleEllipsis,
        expanding,
        width,
        suffix,
        expandNodes,
        expandable,
        ellipsisStr,
        props.rows,
    ]);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        if (singleRowNode.current && status === MEASURE_STATUS.INIT) {
            var offsetHeight = singleRowNode.current.offsetHeight;
            setLineHeight(offsetHeight);
        }
    }, [status]);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function () {
        measure();
    }, [status, midLoc, startLoc, endLoc, lineHeight]);
    var basicStyle = {
        zIndex: -999,
        position: 'fixed',
        opacity: 0,
        padding: 0,
        margin: 0,
    };
    var singleRowNodeStyle = useEllipsis_assign({ whiteSpace: 'nowrap' }, basicStyle);
    // 用css省略的话，需要覆盖单行省略样式
    var mirrorNodeStyle = simpleEllipsis
        ? useEllipsis_assign({ textOverflow: 'clip' }, basicStyle) : basicStyle;
    var ellipsisNode;
    if (status === MEASURE_STATUS.INIT || status === MEASURE_STATUS.BEFORE_MEASURE) {
        ellipsisNode = (react.createElement("div", null,
            react.createElement("div", { ref: singleRowNode, style: singleRowNodeStyle }, status === MEASURE_STATUS.INIT
                ? MEASURE_LINE_HEIGHT_TEXT
                : renderMeasureContent(children, false)),
            react.createElement("div", { ref: mirrorNode, style: useEllipsis_assign({ width: width }, mirrorNodeStyle) }, renderMeasureContent(children, isEllipsis))));
        ellipsisNode = ellipsisNode.props.children;
    }
    else if (status === MEASURE_STATUS.MEASURING) {
        // 计算过程中的占位展示，避免计算造成的抖动
        // 不能设置 width 否则在 table 中会再次造成 resize
        var showStyle = {
            height: lineHeight * rows,
            overflow: 'hidden',
        };
        ellipsisNode = (react.createElement("div", null,
            react.createElement("div", { ref: mirrorNode, style: useEllipsis_assign({ width: width }, mirrorNodeStyle) }, renderMeasureContent(getSlicedNode(midLoc), isEllipsis)),
            react.createElement("div", { style: showStyle }, getSlicedNode(closedLoc.current))));
        ellipsisNode = ellipsisNode.props.children;
    }
    else if (status === MEASURE_STATUS.MEASURE_END) {
        ellipsisNode = renderMeasureContent(getSlicedNode(midLoc), isEllipsis);
    }
    else if (status === MEASURE_STATUS.NO_NEED_ELLIPSIS) {
        ellipsisNode = renderMeasureContent(children, false);
    }
    return { ellipsisNode: ellipsisNode, isEllipsis: isEllipsis, measureStatus: status };
}
/* harmony default export */ var Typography_useEllipsis = (useEllipsis);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Typography/useCssEllipsis.js
var useCssEllipsis_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};


var supportCss = function (key, value) {
    if (typeof window !== 'undefined' && window.CSS && window.CSS.supports) {
        if (!(0,is/* isUndefined */.o8)(value)) {
            return window.CSS.supports(key, value);
        }
        return window.CSS.supports(key);
    }
    if (typeof document !== 'undefined' && document.createElement) {
        var elem = document.createElement('div');
        elem.setAttribute("style", key + ":" + value + ";");
        return typeof elem.style[key] !== 'undefined';
    }
    return false;
};
var mutiEllipsisAttr = {
    display: ' -webkit-box',
    '-webkit-line-clamp': 2,
};
var isSupportMuti = function () {
    return Object.entries(mutiEllipsisAttr).every(function (_a) {
        var _b = useCssEllipsis_read(_a, 2), key = _b[0], value = _b[1];
        return supportCss(key, value);
    });
};
function useCssEllipsis(props) {
    var cssEllipsis = props.cssEllipsis, _a = props.ellipsisStr, ellipsisStr = _a === void 0 ? '...' : _a, suffix = props.suffix, rows = props.rows;
    var simpleEllipsis = (0,react.useMemo)(function () {
        if (!cssEllipsis || (rows > 1 && !isSupportMuti())) {
            return false;
        }
        return ellipsisStr === '...' && !suffix;
    }, [ellipsisStr, cssEllipsis, rows, suffix]);
    var singleRowStyle = {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    };
    var mutiRowsStyle = {
        textOverflow: 'ellipsis',
        whiteSpace: 'normal',
        overflow: 'hidden',
        WebkitLineClamp: "" + props.rows,
        WebkitBoxOrient: 'vertical',
        display: '-webkit-box',
    };
    return {
        simpleEllipsis: simpleEllipsis,
        ellipsisStyle: simpleEllipsis ? (props.rows > 1 ? mutiRowsStyle : singleRowStyle) : {},
    };
}
/* harmony default export */ var Typography_useCssEllipsis = (useCssEllipsis);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Typography/base.js
var base_assign = (undefined && undefined.__assign) || function () {
    base_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return base_assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var base_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};















function getClassNameAndComponentName(props, prefixCls) {
    var type = props.type, bold = props.bold, disabled = props.disabled, mark = props.mark, underline = props.underline, propDelete = props.delete, code = props.code;
    var component = [];
    var className = [];
    if (type) {
        className.push(prefixCls + "-" + type);
    }
    if (disabled) {
        className.push(prefixCls + "-disabled");
    }
    if (bold) {
        component.push('b');
    }
    if (underline) {
        component.push('u');
    }
    if (propDelete) {
        component.push('del');
    }
    if (code) {
        component.push('code');
    }
    if (mark) {
        component.push('mark');
    }
    return {
        component: component,
        className: className,
    };
}
function Base(props) {
    var _a;
    var componentType = props.componentType, style = props.style, className = props.className, children = props.children, editable = props.editable, ellipsis = props.ellipsis, heading = props.heading, blockquote = props.blockquote, rest = __rest(props, ["componentType", "style", "className", "children", "editable", "ellipsis", "heading", "blockquote"]);
    var configContext = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_);
    var getPrefixCls = configContext.getPrefixCls, rtl = configContext.rtl;
    var prefixCls = getPrefixCls('typography');
    var _b = getClassNameAndComponentName(props, prefixCls), component = _b.component, componentClassName = _b.className;
    var _c = base_read((0,react.useState)(false), 2), editing = _c[0], setEditing = _c[1];
    var _d = base_read((0,react.useState)(0), 2), width = _d[0], setWidth = _d[1];
    var resizeTime = (0,react.useRef)(0);
    var editableConfig = (0,is/* isObject */.Kn)(editable) ? editable : {};
    var mergedEditing = 'editing' in editableConfig ? editableConfig.editing : editing;
    var ellipsisConfig = ellipsis
        ? base_assign({ rows: 1, ellipsisStr: '...', cssEllipsis: false }, ((0,is/* isObject */.Kn)(ellipsis) ? ellipsis : {})) : {};
    var EllipsisWrapperTag = ellipsisConfig.wrapper || react.Fragment;
    var _e = base_read((0,useMergeValue/* default */.Z)(false, {
        defaultValue: ellipsisConfig.defaultExpanded,
        value: ellipsisConfig.expanded,
    }), 2), expanding = _e[0], setExpanding = _e[1];
    var _f = Typography_useCssEllipsis(ellipsisConfig), simpleEllipsis = _f.simpleEllipsis, ellipsisStyle = _f.ellipsisStyle;
    var renderMeasureContent = function (node, isEllipsis) {
        var ellipsisStr = !(0,is/* isUndefined */.o8)(ellipsisConfig.ellipsisStr)
            ? ellipsisConfig.ellipsisStr
            : '...';
        var suffix = !(0,is/* isUndefined */.o8)(ellipsisConfig.suffix) && ellipsisConfig.suffix;
        return (react.createElement(EllipsisWrapperTag, null,
            node,
            isEllipsis && !expanding && !simpleEllipsis ? ellipsisStr : '',
            suffix,
            renderOperations(isEllipsis)));
    };
    var _g = Typography_useEllipsis(base_assign(base_assign({}, ellipsisConfig), { children: children, expanding: expanding, width: width, renderMeasureContent: renderMeasureContent, simpleEllipsis: simpleEllipsis || expanding })), ellipsisNode = _g.ellipsisNode, isEllipsis = _g.isEllipsis, measureStatus = _g.measureStatus;
    var handleResize = function (entry) {
        var contentRect = (entry === null || entry === void 0 ? void 0 : entry[0]).contentRect;
        var currentTime = +new Date();
        var diffTime = currentTime - resizeTime.current;
        if (contentRect) {
            var currentWidth = component.includes('code') ? contentRect.width - 18 : contentRect.width;
            var resizeStatus = [MEASURE_STATUS.NO_NEED_ELLIPSIS, MEASURE_STATUS.MEASURE_END];
            // 在 table 中，使用了 cssEllipsis 因为 white-space: "nowrap"，宽度会突然变很大
            // 导致再次触发 resize 计算，进入循环。
            // diffTime 应对短时间内多次触发
            if (resizeStatus.includes(measureStatus) && diffTime > 100) {
                resizeTime.current = currentTime;
                setWidth(currentWidth);
            }
        }
    };
    function renderOperations(isEllipsis) {
        return (react.createElement(react.Fragment, null,
            react.createElement(Operations, base_assign({}, props, { setEditing: setEditing, onClickExpand: onClickExpand, expanding: expanding, isEllipsis: isEllipsis, 
                // 如果是镜像dom的话，渲染在最外层，无法从context中拿到最新config
                currentContext: configContext }))));
    }
    function onClickExpand(e) {
        setExpanding(!expanding);
        props.onClickExpand && props.onClickExpand(e);
        ellipsisConfig.onExpand && ellipsisConfig.onExpand(!expanding, e);
    }
    (0,useUpdate/* default */.Z)(function () {
        ellipsisConfig.onEllipsis && ellipsisConfig.onEllipsis(isEllipsis);
    }, [isEllipsis]);
    function wrap(content, component, props, innerProps) {
        if (innerProps === void 0) { innerProps = {}; }
        var currentContent = content;
        component.forEach(function (c, _index) {
            var _innerProps = _index === 0 ? innerProps : {};
            var _props = (0,is/* isObject */.Kn)(props.mark) && props.mark.color
                ? base_assign({ style: { backgroundColor: props.mark.color } }, _innerProps) : base_assign({}, _innerProps);
            currentContent = react.createElement(c, base_assign({}, _props), currentContent);
        });
        return currentContent;
    }
    var TextComponent;
    if (componentType === 'Paragraph') {
        TextComponent = blockquote ? 'blockquote' : 'div';
    }
    else if (componentType === 'Title') {
        TextComponent = "h" + heading;
    }
    else if (componentType === 'Text') {
        TextComponent = ellipsis ? 'div' : 'span';
    }
    function renderContent() {
        var _a;
        var fullText = mergedToString(react.Children.toArray(children));
        var showTooltip = ellipsisConfig.showTooltip;
        var tooltipType = (0,is/* isObject */.Kn)(ellipsisConfig.showTooltip)
            ? ellipsisConfig.showTooltip.type === 'popover'
                ? 'popover'
                : 'tooltip'
            : 'tooltip';
        var tooltipProps = (0,is/* isObject */.Kn)(ellipsisConfig.showTooltip)
            ? ellipsisConfig.showTooltip.props || {}
            : {};
        var TooltipComponent = (tooltipType === 'popover' ? Popover/* default */.Z : Tooltip/* default */.Z);
        var titleProps = isEllipsis && !showTooltip && !expanding ? { title: fullText } : {};
        var baseProps = base_assign({ style: style }, titleProps);
        var addTooltip = isEllipsis && showTooltip && !expanding;
        var node = (react.createElement(resizeObserver/* default */.Z, { onResize: handleResize },
            react.createElement(TextComponent, base_assign({ className: (0,_util_classNames/* default */.Z)(prefixCls, componentClassName, (_a = {}, _a[prefixCls + "-rtl"] = rtl, _a), className) }, baseProps, (0,omit/* default */.Z)(rest, [
                'spacing',
                'type',
                'close',
                'bold',
                'disabled',
                'mark',
                'underline',
                'delete',
                'code',
                'copyable',
                'isEllipsis',
                'expanding',
                'onClickExpand',
                'setEditing',
                'forceShowExpand',
            ])), simpleEllipsis && measureStatus !== MEASURE_STATUS.INIT && !expanding && isEllipsis
                ? wrap(
                // CSS folding style, need to wrap the text separately.
                renderMeasureContent(react.createElement("span", { style: ellipsisStyle }, children), isEllipsis), component.length ? component : ['span'], props, 
                // The simple-ellipsis class ensures that the ReactNode after the text is displayed correctly (no line breaks)
                // Need to act on the immediate parent node of the text
                { className: prefixCls + "-simple-ellipsis" })
                : wrap(ellipsisNode, component, props))));
        if (addTooltip) {
            return (react.createElement(TooltipComponent, base_assign({ content: fullText }, tooltipProps),
                react.createElement("span", null, node)));
        }
        return node;
    }
    return mergedEditing ? (react.createElement(EditContent, base_assign({}, props, { className: (0,_util_classNames/* default */.Z)(prefixCls, componentClassName, (_a = {}, _a[prefixCls + "-rtl"] = rtl, _a), prefixCls + "-" + TextComponent, className), prefixCls: prefixCls, setEditing: setEditing, editableConfig: editableConfig }))) : (renderContent());
}
/* harmony default export */ var base = (Base);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Typography/title.js
var title_assign = (undefined && undefined.__assign) || function () {
    title_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return title_assign.apply(this, arguments);
};
var title_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


function Title(props) {
    var _a = props.heading, heading = _a === void 0 ? 1 : _a, rest = title_rest(props, ["heading"]);
    return react.createElement(base, title_assign({ heading: heading }, rest, { componentType: "Title" }));
}
Title.displayName = 'Title';
/* harmony default export */ var title = (Title);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Typography/text.js
var text_assign = (undefined && undefined.__assign) || function () {
    text_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return text_assign.apply(this, arguments);
};


function Text(props) {
    return react.createElement(base, text_assign({}, props, { componentType: "Text" }));
}
Text.displayName = 'Text';
/* harmony default export */ var Typography_text = (Text);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Typography/paragraph.js
var paragraph_assign = (undefined && undefined.__assign) || function () {
    paragraph_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return paragraph_assign.apply(this, arguments);
};




function Paragraph(props) {
    var _a = props.spacing, spacing = _a === void 0 ? 'default' : _a, className = props.className;
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var prefixCls = getPrefixCls('typography');
    var classNames = spacing === 'close' ? (0,_util_classNames/* default */.Z)(prefixCls + "-spacing-close", className) : className;
    return react.createElement(base, paragraph_assign({}, props, { componentType: "Paragraph", className: classNames }));
}
Paragraph.displayName = 'Paragraph';
/* harmony default export */ var paragraph = (Paragraph);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Typography/index.js




var Typography_Typography = typography;
Typography_Typography.Title = title;
Typography_Typography.Text = Typography_text;
Typography_Typography.Paragraph = paragraph;
/* harmony default export */ var es_Typography = (Typography_Typography);


/***/ }),

/***/ 38460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconCopyComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-copy")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    d: "M20 6h18a2 2 0 0 1 2 2v22M8 16v24c0 1.105.891 2 1.996 2h20.007A1.99 1.99 0 0 0 32 40.008V15.997A1.997 1.997 0 0 0 30 14H10a2 2 0 0 0-2 2Z"
  }));
}

var IconCopy = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconCopyComponent);
IconCopy.defaultProps = {
  isIcon: true
};
IconCopy.displayName = 'IconCopy';
/* harmony default export */ __webpack_exports__["Z"] = (IconCopy);

/***/ })

}]);